import { IUsersSearchModel } from "@/Administration/Models/UI/Users/IUsersSearchModel";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonImageControl } from "@/Common/Components/Buttons/ButtonImageControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { Person } from "@/Common/Models/Person/Person";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";

import img_icon_create_patient from "@/Globals/_images/icons/sidebar/create-patient.png";

interface IUserSearchComponentProps {
    transitionClass?: string;
    userSearchModel: IUsersSearchModel;
    operation: number;
    selectedEmployee?: EmployeeUIModel;
}

class UserSearchComponentState {
    public searchResult: Immutable.List<Person>;
    public textSearch: string;
    public hideInactiveUsers: boolean;
    public changePassword: boolean;
    public changeActivation: boolean;
}

class UserSearchComponent extends BaseReactComponent<IUserSearchComponentProps, UserSearchComponentState> {
    constructor(props: IUserSearchComponentProps) {
        super(props);

        const initialState = new UserSearchComponentState();
        initialState.textSearch = props.userSearchModel.get("SearchText") || "";
        initialState.hideInactiveUsers = false;
        initialState.changePassword = false;
        initialState.changeActivation = false;
        this.state = initialState;
    }

    public componentDidMount(): void {
        sessionStore.dispatch(this.props.operation);
    }

    public componentDidUpdate(prevProps: IUserSearchComponentProps): void {
        const currentSearchResults = this.props.userSearchModel.get("SearchEmployeeResult");
        const prevSearchResults = prevProps.userSearchModel.get("SearchEmployeeResult");
        const currentSearchText = this.props.userSearchModel.get("SearchText");
        const prevSearchText = prevProps.userSearchModel.get("SearchText");

        const isSameSearch = currentSearchText === prevSearchText || this.state.textSearch !== currentSearchText;

        if (currentSearchResults !== prevSearchResults || !isSameSearch) {
            this.mutateState(s => {
                s.searchResult = currentSearchResults;
                s.textSearch = currentSearchText;
            });
        }
    }

    public render(): JSX.Element {
        let employees = Immutable.List<Person>();
        if (this.state != null && this.state.searchResult != null) {
            employees = this.state.searchResult;
            if (employees && employees.count() > 0) {
                employees = employees.toArray().sortByProperty(emp => emp.LastName.trim()).toImmutable();
            }
        }

        if (this.props.userSearchModel.get("HideInactiveUsers")) {
            employees = employees.toArray().filter(x => !x.EmployeeSearchModel.IsInactive).toImmutable();
        }

        if (!IsNullOrWhiteSpace(this.state.textSearch)) {
            employees = employees.toArray().filterSearch(this.state.textSearch, item => `${item.FirstName} ${item.LastName} ${item.Name} ${item.EmployeeSearchModel.UserName}`).toImmutable();
        }

        // only msupport can see msupport and API users
        if (sessionStore.getCurrentEmployee().Model.UserName !== "msupport") {
            employees = employees.toArray().filter(employee => employee.EmployeeSearchModel.UserName !== "msupport" && employee.EmployeeSearchModel.Type !== EmployeeType.Api).toImmutable();
        }

        return (
            <div className="fxheight transition full-border admin-users-search">

                <div className="user-search">
                    <div className="flex-container s">
                        <div className="search-field" style={{ width: "100%", maxHeight: "40px" }}>
                            <div className="gf">
                                <span className="glyphicon glyphicon-search" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <TextboxControl
                                    onMountFocus
                                    debounceMs={400}
                                    value={this.state.textSearch}
                                    name="text_search_users"
                                    className="fullWidth"
                                    placeholder={cacheStore.GetString("SearchLabel")}
                                    autoComplete="off"
                                    onChange={value => this.mutateState(
                                        s => s.textSearch = value,
                                        () => sessionStore.dispatch(LocalOperations.AdministrationUsers.setTextSearch, { TextSearch: value })
                                    )}
                                    dataCy="userprofile-sidebarUserSearch"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="patient-create-options flex-container">
                        <div>
                            <CheckboxControl
                                id="hideInActiveUser_check"
                                dataCy="user-hideInActiveUser"
                                checked={this.props.userSearchModel.get("HideInactiveUsers")}
                                operation={LocalOperations.AdministrationUsers.HideInactiveUsers}
                                target={CheckboxTarget.Mytle_Admin_HideInactiveUsersLabel}
                                label={cacheStore.GetString("HideInactiveUsersLabel")}
                            />
                        </div>
                        <div>
                            <ButtonImageControl
                                className="no-padding pointer"
                                onClick={() => sessionStore.dispatch(LocalOperations.AdministrationUsers.ShowCreateEmployeePopup)}
                                imagePath={img_icon_create_patient}
                                id="createEmployee"
                                dataCy="userProfile-create"
                            />
                        </div>
                    </div>
                </div>

                <div className="user-search-results scrollable">
                    <div className="pointer">
                        {employees.map((x: Person, i: number) => {
                            let type: string = "";
                            if (x.EmployeeSearchModel.Type === EmployeeType.Assistant)
                                type = cacheStore.GetString("Enums_EmployeeType_Assistant");
                            if (x.EmployeeSearchModel.Type === EmployeeType.Practician)
                                type = cacheStore.GetString("Enums_EmployeeType_Practician");
                            if (x.EmployeeSearchModel.Type === EmployeeType.Admin)
                                type = cacheStore.GetString("Enums_EmployeeType_Admin");
                            if (x.EmployeeSearchModel.Type === EmployeeType.Api)
                                type = cacheStore.GetString("Enums_EmployeeType_Api");

                            let selectedClass = "";
                            if (this.props.selectedEmployee != null) {
                                selectedClass = (x.EmployeeSearchModel.Inactivable_id == this.props.selectedEmployee.ContactFacetId) ? " selected" : "";
                            }

                            return (
                                <div
                                    className={"user-search-item" + selectedClass}
                                    id={`__a${i}`}
                                    onFocus={() => this.onFocus()}
                                    onClick={() => this.selectItem(x)}
                                    key={x.ContactFacetId}
                                >
                                    <div>
                                        {(x.EmployeeSearchModel.IsInactive)
                                            ? (
                                                <div>
                                                    <div className={x.LastName.length > 15 ? "user-search-ellipsis lastName" : ""} style={{ float: "left" }}>
                                                        <strong style={{ "color": "red" }}>
                                                            {x.LastName.toUpperCase().trim()}
                                                        </strong>
                                                    </div>
                                                    <div className={x.FirstName.length > 10 ? "user-search-ellipsis firstName" : ""}>
                                                        <strong style={{ "color": "red" }}>
                                                            {", " + x.FirstName.charAt(0).toUpperCase() + x.FirstName.slice(1)}
                                                        </strong>
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                <div>
                                                    <div className={x.LastName.length > 20 ? "user-search-ellipsis lastName" : ""} style={{ float: "left" }}>
                                                        <strong>
                                                            {x.LastName.toUpperCase().trim()}
                                                        </strong>
                                                    </div>
                                                    <div className={x.FirstName.length > 12 ? "user-search-ellipsis firstName" : ""}>
                                                        <strong>
                                                            {", " + x.FirstName.charAt(0).toUpperCase() + x.FirstName.slice(1)}
                                                        </strong>
                                                    </div>

                                                </div>
                                            )
                                        }
                                    </div>
                                    <div />
                                    <div className="flex-container medical-note">
                                        <div className="flx-col a">
                                            {(x.EmployeeSearchModel.IsInactive) ? <div style={{ "color": "red" }} data-cy="user-username">{x.EmployeeSearchModel.UserName}</div> : <div data-cy="user-username">{x.EmployeeSearchModel.UserName}</div>}
                                            <div>{(x.EmployeeSearchModel.IsInactive) ? <a style={{ "color": "green", "textDecoration": "underline" }} onClick={e => this.deactivateUsers(x, e)} data-cy="user-inactivate">{cacheStore.GetString("ReactivateLabel")}</a> : <a style={{ "color": "red", "textDecoration": "underline" }} onClick={e => this.deactivateUsers(x, e)} data-cy="user-deactivate">{cacheStore.GetString("DeactivateLabel")}</a>}</div>
                                        </div>

                                        <div className="flx-col" style={{ textAlign: "right" }}>
                                            <div>
                                                {(x.EmployeeSearchModel.IsInactive) ? <span style={{ "color": "red" }}>{type}</span> : <span>{type}</span>}
                                            </div>
                                            {!cacheStore.ClinicSettings.EnableSSOAuthentication && (
                                                <>
                                                    <div />
                                                    <div>
                                                        {(!x.EmployeeSearchModel.IsInactive && x.EmployeeSearchModel.Type !== EmployeeType.Api) &&
                                                            <a onClick={e => this.reinitUsersPopupOpen(x, e)}>{cacheStore.GetString("ResetLabel")}</a>
                                                        }
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

            </div>
        );
    }

    private selectItem(item: Person): void {
        sessionStore.dispatch(
            LocalOperations.AdministrationUsers.GetEmployeeInfo,
            {
                EmployeeId: item.EmployeeSearchModel.Inactivable_id
            }
        );
    }

    private deactivateUsers(item: Person, e: React.MouseEvent): void {
        e.stopPropagation();

        sessionStore.dispatch(LocalOperations.AdministrationUsers.InActivateUsers, {
            IsInActive: !item.EmployeeSearchModel.IsInactive,
            contactId: item.EmployeeSearchModel.Contact_id
        });
    }

    private reinitUsersPopupOpen(item: Person, e: React.MouseEvent): void {
        e.stopPropagation();
        sessionStore.dispatch(LocalOperations.AdministrationUsers.ReinitUsersPopupOpen, {
            EmployeeId: item.EmployeeSearchModel.Inactivable_id
        });
    }

    private onFocus(): void {
        const employees = this.state.searchResult;

        window.setTimeout(() => $("#" + employees).select(), 300);
    }
}

export { UserSearchComponent };
